export default __webpack_public_path__ + "static/media/oscer-pres-cough.b03dcf9e.svg";